<template>
  <div>
    <Row type="flex" justify="space-between">
      <Col>
        <RadioGroup v-model="query.all" @on-change="changeAll">
          <Radio label="0">全部项目</Radio>
          <Radio label="1">我的项目</Radio>
        </RadioGroup>
      </Col>
      <Col>
        <Button
          type="success"
          style="float:right;"
          icon="md-add"
          @click="addProject"
          >添加项目</Button
        >
      </Col>
    </Row>
    <Row class="margin-top-10" type="flex" :gutter="16">
      <Col class="query-item">
        <Input v-model="query.projectName" placeholder="项目名称" clearable />
      </Col>
      <Col class="query-item" span="6">
        <Select
          v-model="query.resourceId"
          placeholder="资源名称"
          filterable
          clearable
        >
          <Option
            v-for="item in resourceList"
            :value="item.id"
            :key="item.id"
            >{{ item.companyName }}</Option
          >
        </Select>
      </Col>
      <Col>
        <Button type="info" icon="md-query" @click="search()">筛选</Button>
      </Col>
    </Row>
    <div class="margin-top-10">
      <Card style="overflow-x: auto;">
        <Table :data="projectList" :columns="projectCloumn" width="2000">
          <template slot-scope="{ row, index }" slot="projectType">
            {{ row.projectType.name }}
          </template>

          <template slot-scope="{ row, index }" slot="action">
            <Dropdown trigger="click" :transfer="true">
              <Button type="primary">
                操作列表
                <Icon type="ios-arrow-down"></Icon>
              </Button>
              <DropdownMenu slot="list">
                <!-- <DropdownItem>
									<Button type="info" @click="showDetail(row)">查看</Button>
								</DropdownItem> -->

                <DropdownItem>
                  <Button
                    type="primary"
                    @click="update(row)"
                    v-if="row.creatorId == $store.state.user.userId"
                    >更新</Button
                  >
                </DropdownItem>
                <DropdownItem>
                  <Button
                    type="error"
                    v-if="
                      row.entryUserId == $store.state.user.userId ||
                        $store.state.user.role == '系统管理员'
                    "
                    @click="remove(row)"
                    >删除</Button
                  >
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </template>
          <template slot-scope="{ row }" slot="resourceList">
            <Row v-for="(item, index) in row.projectResource" :key="index">{{
              item.resource.companyName
            }}</Row>
          </template>
        </Table>
        <Page
          class="margin-top-10"
          :total="projectCount"
          @on-change="changePage"
          :current="query.page"
          :page-size="query.size"
          show-total
          show-elevator
        />
      </Card>
    </div>

    <Modal
      v-model="addProjectModal"
      :title="addProjectModalTitle"
      :mask="true"
      :mask-closable="false"
      :footer-hide="true"
    >
      <addProject ref="addProjectCom" @saved="handleSaveProject"></addProject>
    </Modal>
    <Modal
      v-model="projectDetailModal"
      title="项目详情"
      :mask="true"
      :mask-closable="false"
      footer-hide
    >
      <projectDetail ref="projectDetail"></projectDetail>
    </Modal>
  </div>
</template>
<script>
import addProject from "./addProject";
import projectDetail from "./projectDetail";
import project from "@/api/project.js";
import resource from "@/api/resource.js";
import { hasOneOf } from "@/libs/tools";
export default {
  components: {
    addProject,
    projectDetail,
  },
  data() {
    return {
      query: {
        page: 1,
        size: 20,
      },
      resourceList: [],
      addProjectModalTitle: "",
      addProjectModal: false,
      projectDetailModal: false,

      projectList: [],
      projectCount: 0,
      projectCloumn: [
        {
          title: "项目名称",
          key: "name",
          align: "center",
        },
        {
          title: "使用资源",
          slot: "resourceList",
          align: "center",
        },
        {
          title: "开始时间",
          key: "startTime",
          align: "center",
          render: function(h, params) {
            if (this.row.startTime) {
              return h(
                "div",
                new Date(this.row.startTime).toLocaleDateString()
              );
            }
          },
        },
        {
          title: "结束时间",
          key: "endTime",
          align: "center",
          render: function(h, params) {
            if (this.row.endTime) {
              return h("div", new Date(this.row.endTime).toLocaleDateString());
            }
          },
        },
        {
          title: "项目状态",
          key: "status",
          align: "center",
        },
        {
          title: "任务类别",
          slot: "projectType",
          align: "center",
        },
        {
          title: "任务概述",
          key: "describe",
          align: "center",
        },
        {
          title: "合同单价",
          key: "unitprice",
          align: "center",
        },
        {
          title: "数据总量",
          key: "totalCount",
          align: "center",
        },
        {
          title: "合同总金额",
          key: "amountOfMoney",
          align: "center",
        },
        {
          title: "项目负责人评价",
          key: "appraise",
          align: "center",
        },

        {
          title: "更新时间",
          key: "inTime",
          align: "center",
          render: function(h, params) {
            if (this.row.inTime) {
              //时区处理
              var localDate = new Date(this.row.inTime);
              var localTime = localDate.getTime();
              var localOffset = localDate.getTimezoneOffset() * 60 * 1000;

              return h(
                "div",
                new Date(localTime + localOffset).toLocaleString()
              );
            }
          },
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
          minWidth: 120,
        },
      ],
    };
  },
  methods: {
    search() {
      this.query.page = 1;
      this.getData();
    },
    getResourceList() {
      let _this = this;
      resource.allResourceList().then((res) => {
        _this.resourceList = res.data;
      });
    },
    hasRole(roles) {
      return hasOneOf(this.$store.state.user.role, roles);
    },
    changePage(p) {
      this.query.page = p;
      this.getData();
    },
    addProject() {
      this.addProjectModal = true;
      this.addProjectModalTitle = "添加新项目";
      this.$refs.addProjectCom.reset();
    },

    getData() {
      let _this = this;
      project.projectList(this.query).then((res) => {
        _this.projectList = res.data.data;
        console.log(_this.projectList);
        _this.projectCount = res.data.count;
      });
    },
    showDetail(row) {
      let _this = this;
      console.log(row);
      _this.projectDetailModal = true;
      _this.$refs.projectDetail.setData(row);
    },
    update(row) {
      this.addProjectModal = true;
      this.addProjectModalTitle = "更新项目";
      this.$refs.addProjectCom.setData(row);
    },
    changeAll(e) {
      this.query.page = 1;
      this.getData();
    },
    remove(row) {
      let _this = this;
      this.$Modal.confirm({
        title: "是否删除该项目?",
        onOk: function() {
          project
            .deleteProject(row.id)
            .then((res) => {
              _this.getData();
            })
            .catch((err) => {
              _this.$Message.error(
                err?.response?.data?.message ||
                  JSON.stringify(err?.response?.data)
              );
            });
        },
      });
    },
    handleSaveProject() {
      this.addProjectModal = false;
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getResourceList();
  },
};
</script>
